import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 40px;
  width: 100%;
  max-width: 450px;

  img {
    width: 150px; /* Ajuste o tamanho do seu logo */
    margin-bottom: 32px;
  }

  form {
    width: 100%;
    text-align: center;

    h1 {
      margin-bottom: 24px;
      font-size: 24px;
      color: #333;
    }
  }

  a {
    color: #007bff;
    display: block;
    margin-top: 24px;
    text-decoration: none;
    transition: color 0.2s;

    &:hover {
      color: ${(props) => props.theme.colors.primary_dark};
    }
  }
`;
